import React from 'react'
import Settings from 'Event/template/Townhall/Dashboard/Header/HeaderConfig/Settings'
import Styling from 'Event/template/Townhall/Dashboard/Header/HeaderConfig/Styling'
import SettingsPanel from 'organization/Event/DashboardConfig/ComponentConfigPanel/SettingsPanel'
import StylingPanel from 'organization/Event/DashboardConfig/ComponentConfigPanel/StylingPanel'
import {useSaveTemplate} from 'Event/TemplateUpdateProvider'
import Config from 'organization/Event/Configurable/Config'

export function HeaderConfig() {
  const save = useSaveTemplate()

  return (
    <Config title="Townhall" onSave={save}>
      <SettingsPanel>
        <Settings />
      </SettingsPanel>
      <StylingPanel>
        <Styling />
      </StylingPanel>
    </Config>
  )
}
